const EVENT_TYPES = Object.freeze({
    IS_DEAL_EXPORTED: 'DXP_IS_DEAL_EXPORTED',
    RELOAD_DEAL: 'DXP_RELOAD_DEAL',
});
const getChildWindow = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (window._CYPRESS_SE === true) {
        return window;
    }
    const iframe = document.getElementById('se_frame');
    if (!iframe || !iframe.contentWindow) {
        throw new Error("Sales enablement iframe or it's window not found!");
    }
    return iframe.contentWindow;
};
export default function useCheckoutCommunication() {
    return {
        sendIsDealExported() {
            getChildWindow().postMessage({
                type: EVENT_TYPES.IS_DEAL_EXPORTED,
                payload: true,
            }, '*');
        },
        reloadDeal() {
            getChildWindow().postMessage({
                type: EVENT_TYPES.RELOAD_DEAL,
                payload: {},
            }, '*');
        },
    };
}
//# sourceMappingURL=useCheckoutCommunication.js.map